import i18n from 'i18next';

export const columns = [
  {
    id: 'formName',
    numeric: false,
    disablePadding: false,
    label: i18n.t('inspections.formName'),
    needSorting: true,
    width: '30%',
  },
  {
    id: 'assetCount',
    numeric: true,
    disablePadding: false,
    label: i18n.t('inspections.assetsCount'),
    needSorting: true,
    width: '30%',
  },
  {
    id: 'unitType',
    numeric: false,
    disablePadding: false,
    label: i18n.t('inspections.unitType'),
    needSorting: true,
    width: '30%',
  },
  {
    id: 'actions',
    label: '',
  },
];
